import axios from 'axios';
import axiosRetry from 'axios-retry';
import {pick, merge, isObject} from 'lodash';
import {encodeQueryData} from "../Wizard/utils";
//import * as utils from '../mcc/Utils';
//import _ from "../mcc/underscorePlus";
//const querystring = require('querystring');


export default function QuarkRender(config)
{
    this.init(config);
}
QuarkRender.prototype = {

    defaultConfig: {
        baseURL: 'https://service.metrocreativeconnection.com/wizard/',
        timeout: 60000,  //MS? todo seems poky nothing over 5s from paw?
        networkRetries: 3 // network/server error retries(note timout applies to all...?)
    },

    init: function init(config){
        this.config = merge({}, this.defaultConfig, config);
        var instanceOptions = pick(this.config, 'baseURL','timeout');
        this.client = axios.create(instanceOptions);
        this.session = '';
        const self = this;

        // Network retries
        axiosRetry(this.client, { retries: this.config.networkRetries });

        // Set up session for effcient file caching
        // Only needed on render request but no harm else where
        this.client.interceptors.request.use(function (config) {
            config.params = merge({},config.params,{session:self.session});
            return config;
        }, function (error) {
            // Do something with request error
            // how the hell could it fail ...
            return Promise.reject(error);
        });

        // Check proper quark-render response
        this.client.interceptors.response.use(function (response) {
            if (!self.goodResponse(response) )
            {
                // Assume if we have data it does have a message & status
                const data = response.data || {
                    message: 'Missing JSON data',
                    status: '-1000'
                };

                //Note: this throws a warning could use Custom error
                return Promise.reject({
                    response,
                    message: data.message,
                    status: data.status
                });
            }
            if (response.data.session) {
                self.session = response.data.session;
            }
            return response;
        }, function (error) {
            // Do something with response error
            return Promise.reject(error);
        });
    },

    isOnLine: function isOnLine() {
        // Navigator is a browser only object
        return !navigator || navigator.onLine;
    },

    // todo make this an interceptor
    goodResponse: function (response)
    {
        // TBD add status to mcc replies
        return response.config.responseType !== 'json' ||
            ( isObject(response.data) && ('status' in response.data)); //todo check value
    },

    submitRequest: function (options) {

        if (!this.isOnLine()) {
            return Promise.reject({status: 1000}, 'offline').promise();
        }

        const callConfig = merge({
                url: options.queryPath,
                withCredentials: true,
                //retries: this.config.commandRetries, // see customer interceptor
                responseType: 'json' //TBD other response type - assets, reports ....
            },
            options);

        return this.client(callConfig)
            .then(function(response){

                return response.data;

            }).catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    //OR
                    // and AOD status less than 0
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);

                throw error;
            });
    },

    render: function({template, content, overlays, options, output})
    {
        const data = {
            template,
            content,
            overlays,
            options,
            output
        };

        return this.submitRequest({
            queryPath: 'render',
            method: 'POST',
            data
        }).then(reply=>{
            if (reply.status !== 'OK') {
                console.error(reply.error);
                throw new Error('Render failed - please try again');
            }
            return reply;
        });
    },

    // probably dont need content, options
    gather: function(data)
    {
        return this.submitRequest({
            queryPath: 'gather',
            method: 'POST',
            data
        }).then(reply=>{
            if (reply.status !== 'OK') {
                console.error(reply.error);
                throw new Error('Gathering files failed - please try again');
            }
            return reply;
        });
    },

    email: function(data)
    {
        return this.submitRequest({
            queryPath: 'email',
            method: 'POST',
            data
        }).then(reply=>{
            // todo flesh out error message using accepted & rejected
            if (reply.status !== 'OK') {
                console.error(reply.error);
                throw new Error('Email failed - please try again');
            }
            return reply;
        });
    },

    convert: function({fileName, ...data})
    {
        return this.submitRequest({
            queryPath: 'convert/'+fileName,
            method: 'POST',
            data,
            responseType: 'blob'
  //      }).then(response=>{
  //          return response.data;
        });
    },

    getConvertUrl: function({fileName, ...data}) {
        return this.config.baseURL + 'convert/' + fileName + '?' + encodeQueryData(data);
    }
};